import flattenMessages from '../flattenMessages';
import en from './en.json';
import es from './es.json';
import ru from './ru.json';
import zh from './zh.json';

export default {
  en: flattenMessages(en, 'bitcoin'),
  es: flattenMessages(es, 'bitcoin'),
  ru: flattenMessages(ru, 'bitcoin'),
  zh: flattenMessages(zh, 'bitcoin'),
};
